import type { ProblemLabels } from '@/pages/landing/types'

export default function ProblemSection({ labels }: { labels: ProblemLabels }) {
  return (
    <section className="py-[76px] px-[22px]">
      <div className="max-w-[1080px] mx-auto">
        <div className="max-w-[46ch] mx-auto text-center mb-11">
          <span className="font-script text-flame text-xl inline-block -rotate-1">{labels.eyebrow}</span>
          <h2 className="font-body font-extrabold text-ink text-3xl md:text-4xl tracking-tight mt-1">
            {labels.title} <span className="sketch">{labels.highlight}</span>
          </h2>
          <p className="text-ink-soft text-lg mt-3 leading-relaxed">{labels.body}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[18px]">
          {labels.stats.map((stat, i) => (
            <div
              key={i}
              className="rounded-[18px] p-6 text-center bg-card border-2 border-line shadow-soft transition-all hover:border-ink hover:shadow-hard hover:-translate-y-1"
            >
              <span className="text-3xl block mb-3.5">{stat.icon}</span>
              <div className="font-body font-extrabold text-3xl mb-1 tabular-nums text-flame">{stat.value}</div>
              <p className="text-sm text-ink-soft">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
